import React, { useEffect, useState } from 'react';
import { Button, Collapse, Tabs, Tooltip } from 'antd';
import { FiArrowUpLeft } from 'react-icons/fi';
import { CornersInIcon, CornersOutIcon, PictureInPictureIcon } from '@phosphor-icons/react';
import { PopoutWindowProps } from '../../../../@types/types';

const PopoutWindow: React.FC<PopoutWindowProps> = ({
    children,
    className = '',
    panes,
    isOpenByDefault = true,
    iconForButton,
    tooltip,
    isTabBasedContent = true,
    tabTitle,
    buttonID,
    isMaximizedByDefault = false,
}) => {
    const [isMaximized, setIsMaximized] = useState(isMaximizedByDefault);
    const [expand, setExpand] = useState(isOpenByDefault);

    const toggleMaximize = () => {
        setIsMaximized(!isMaximized);
        setExpand(!expand);
    };

    const handleShow = () => {
        if (isMaximizedByDefault) {
            setIsMaximized(true);
        } else {
            setExpand(true);
        }
    };

    const handleClose = () => {
        setExpand(false);
        setIsMaximized(false);
    };

    const items = panes.map((pane) => ({
        label: pane.tab,
        key: pane.key,
        children: <div>{pane.content}</div>,
    }));

    useEffect(() => {
        //call the onMinMaxPopoutCallback function from the panes array
        const pane = panes.find(p => p.onMinMaxPopoutCallback);
        if (pane && expand) {
            pane.onMinMaxPopoutCallback?.();
        }
    }, [expand]);

    return (
        <>
            {tooltip ? (
                <Tooltip placement="left" title={tooltip}>
                    <Button
                        id={buttonID}
                        type="default"
                        size="large"
                        className={`float_button ${expand ? 'hide' : ''}`}
                        onClick={handleShow}
                        icon={iconForButton ? iconForButton : <FiArrowUpLeft size={28} />}
                    />
                </Tooltip>
            ) : (
                <Button
                    type="default"
                    size="large"
                    className={`float_button ${expand ? 'hide' : ''}`}
                    onClick={handleShow}
                    icon={iconForButton ? iconForButton : <FiArrowUpLeft size={28} />}
                />
            )}

            {/* <Collapse accordion={false} expandIconPosition="end"> */}
                <div
                    className={`popup ${className} ${expand && 'expand'} ${isMaximized && 'maximized'} ${!isMaximized && !expand && 'collapse'}`}
                >
                    <div className="top_bar">
                        <Button
                            title={"Minimize"}
                            type="text"
                            icon={<PictureInPictureIcon size={32} color="#fcfcfc"/>}
                            onClick={handleClose}
                        >
                        </Button>
                        <b
                            style={{
                                color:"white"
                            }}
                        >
                            {tabTitle}
                        </b>
                        <Button
                            type="text"
                            title={isMaximized ? "Minimize" : "Maximize"}
                            className="max_min" onClick={toggleMaximize}>
                            {isMaximized ? <CornersInIcon size={24} color="#fcfcfc"/> :
                                <CornersOutIcon size={32} color="#fcfcfc"/>}

                        </Button>
                    </div>
                    <div className={`popup__content ${!isMaximized && !expand && 'close'}`}>
                        {
                            isTabBasedContent ? (
                                <Tabs
                                    onChange={(key) => {
                                      //fire the callback function from item.onPaneChangeCallback
                                        const pane = panes.find(p => p.key === key);
                                        if (pane?.onPaneChangeCallback) {
                                            pane.onPaneChangeCallback();
                                        }
                                    }}
                                    defaultActiveKey="1" items={items} />
                            ) : (
                                <div className="popup__content__container">
                                    {children}
                                </div>
                            )
                        }
                    </div>
                </div>
            {/* </Collapse> */}
        </>
    );
};

export default PopoutWindow;
